import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { UseFormReturn } from 'react-hook-form';
import Grid from '@mui/material/Grid';

import { FormItem } from 'components/shared';
import { validationRules } from 'helpers/utils';
import TextAreaElement from 'components/muiInputWrappers/TextAreaElement';

function TitleForm({
  form,
  isEditable = true,
  titleModal
}: {
  form: UseFormReturn;
  isEditable?: boolean;
  titleModal?: string;
}) {
  const { t } = useTranslation('global');
  const { validateSpaces } = validationRules();

  return (
    <Grid marginTop={3} paddingX={3}>
      {isEditable ? (
        <>
          <FormItem style={{ width: '100%' }}>
            <TextAreaElement
              form={form}
              maxLength={100}
              maxRows={2}
              name="title"
              placeholder={t('survey.template.withoutTitle')}
              size="small"
              validation={{ validate: validateSpaces }}
              variant="outlined"
              fullWidth
              required
            />
          </FormItem>
          <Grid marginBottom={2} marginTop={3}>
            <TextAreaElement
              form={form}
              maxLength={500}
              maxRows={4}
              name="description"
              placeholder={t('survey.template.descriptionOptional')}
              validation={{ validate: validateSpaces }}
            />
          </Grid>
        </>
      ) : (
        <>
          <Typography fontWeight="500" variant="h5">
            {form.getValues('title') ||
              titleModal ||
              t('survey.template.withoutTitle')}
          </Typography>
          <Typography variant="body1">
            {form.getValues('description')}
          </Typography>
        </>
      )}
    </Grid>
  );
}

export default TitleForm;
